import { Outlet } from "react-router-dom"
const MainMaterial = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainMaterial;